<template>
  <div class="service-floater">
    <div class="service-cs">
        <img src="./img/nav/customer-service.svg" alt="">
        <div class="contact" @click="openw()">
            <p>Contact CS</p>
        </div>
    </div>
    <div class="service-download">
        <img src="./img/nav/App-downlaod.svg" alt="">
        <div class="qr-box">
            <div class="bg">
                <vue-qr
                    class="codeQr"
                    :margin="0"
                    colorDark="#000"
                    colorLight="#fff"
                    :text="downloadData[0].url"
                    :logoScale="0.2"
                    :size="80"
                ></vue-qr>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import { mapState } from "vuex";
export default {
    components: { VueQr },
    data(){
        return{
            dialogDown:false
        }
    },
    computed:{
        downloadData() {
          return [{ url: this.appJump }];
        },
         ...mapState({
            appJump: (state) => state.linkList.appJump,
        }),
    },
    methods:{
      openw() {
        window.LiveChatWidget ? window.LiveChatWidget.call('maximize') : ''
      },
    }
}
</script>

<style lang="scss">
.service-floater{
    border-radius: 10px;
    background: linear-gradient(118.88deg, rgba(71, 71, 71, 1) 0%, rgba(50, 54, 49, 1) 100%);
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    display: flex;
    position: fixed;
    bottom: 50px;
    right: 50px;
    flex-direction: column;
    // padding: 5px;
    z-index:99;
    >img {
        display: block;
        height: 28px;
        padding: 5px 3px 0;
        width: auto;
    }
    .service-cs {
        position: relative;
        // padding-bottom: 5px;
        padding: 5px;
        // margin-bottom: 5px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        cursor: pointer;
        z-index:1;
        &:hover{
            .contact{
                display: inline-block;
            }
        }
        .contact{
            cursor: pointer;
            &:hover{
                display: inline-block;
            }
            display: none;
            margin-right:30px;
            position: absolute;
            left:-94px;
            top:1px;
            border-radius: 4px;
            background: linear-gradient(118.88deg, #474747 0%, #323631 100%);
            padding:5px;
            z-index:10;
            p{
                border-radius: 4px;
                background: #F3B867;
                padding:5px;
                font-weight: 400;
            }
        }
    }
    .service-download {
        padding: 5px;
        position: relative;
        cursor: pointer;
        &:hover{
            .qr-box{
                display: flex;
            }
        }
        .qr-box{
            display: none;
            position: absolute;
            border-radius: 6px;
            background: linear-gradient(118.88deg, #474747 0%, #323631 100%);
            width:100px;
            height:100px;
            // display: flex;
            align-items: center;
            left:-115px;
            top:-55px;
            transition: all .3s;
            z-index:10;
            .bg{
                width:90px;
                height:90px;
                line-height:100px;
                background-color: #fff;
                border-radius:6px;
                margin: 0 auto;
            }
            .codeQr{
                width:90px;
                height:90px;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                // border-radius:16px !important;
                img{
                    // border-radius:16px !important;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/serviceFloater.vue